/**
 * Helper de auditoria — chama a RPC log_audit_event (migration 75).
 *
 * O ator é resolvido no banco a partir de auth.uid() (não dá pra forjar pelo
 * front). audit_events e a RPC ainda não estão nos tipos gerados, então a
 * chamada usa cast pontual. Nunca lança: falha de auditoria não pode quebrar o
 * fluxo principal (login, venda).
 */
import { supabase } from '@/components/atomic-crm/providers/supabase/supabase';

export type AuditParams = {
  entity: string;
  action: string;
  entityId?: string | number | null;
  summary?: string | null;
  before?: unknown;
  after?: unknown;
  metadata?: unknown;
  /**
   * Quando true, colapsa repetições do mesmo ator no mesmo alvo numa linha só
   * (atualiza a hora + conta acessos), em vez de inserir uma nova. Usado na
   * visualização de cliente pra não explodir o log.
   */
  dedupe?: boolean;
};

export async function logAuditEvent(p: AuditParams): Promise<void> {
  try {
    await (supabase as any).rpc('log_audit_event', {
      p_entity: p.entity,
      p_action: p.action,
      p_entity_id: p.entityId == null ? null : String(p.entityId),
      p_summary: p.summary ?? null,
      p_before: p.before ?? null,
      p_after: p.after ?? null,
      p_metadata: p.metadata ?? null,
      p_dedupe: p.dedupe ?? false,
    });
  } catch (error) {
    // Auditoria é best-effort: loga no console e segue.
    console.error('[audit] log_audit_event falhou:', error);
  }
}
